import React, { useCallback } from "react";

import { faBriefcase } from "@fortawesome/pro-solid-svg-icons/faBriefcase";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";

import { useConfigProvider } from "../../../../ConfigProvider";
import ResourceLinkInsertCallback from "../../type/ResourceLinkInsertCallback";
import ToggleButton from "../ToggleButton";

interface ResourceLinkInsertProps {
  onInsert?: ResourceLinkInsertCallback;
}

export const ResourceLinkInsert = ({ onInsert }: ResourceLinkInsertProps) => {
  const configProvider = useConfigProvider();

  const handleClick = useCallback(() => {
    onInsert?.();
  }, [onInsert]);

  return (
    <Tooltip title={configProvider.formatMessage("ui.emailBody.actions.insertResourceLink")}>
      <ToggleButton onClick={handleClick}>
        <FontAwesomeIcon icon={faBriefcase} />
      </ToggleButton>
    </Tooltip>
  );
};

export default ResourceLinkInsert;
